import MerchantNotes from './MerchantNotes'

export default MerchantNotes
